import PropTypes from 'prop-types';
import React from 'react';
import { BaseCard, BaseCardBody, BaseCardHeader } from '@unite-us/ui';
import FacesheetScreenings from '../screenings/FacesheetScreenings';

export default function ScreeningHistorySection({ className, embeddedMode, params }) {
  const content = <FacesheetScreenings historyMode params={params} />;

  if (embeddedMode) {
    return (
      <div className={className}>
        {content}
      </div>
    );
  }

  return (
    <BaseCard>
      <BaseCardHeader
        title={(
          <span className="text-base font-semibold leading-6 text-brand-blue">
            Screening and Navigation History
          </span>
        )}
      />
      <BaseCardBody>
        {content}
      </BaseCardBody>
    </BaseCard>
  );
}

ScreeningHistorySection.propTypes = {
  className: PropTypes.string,
  embeddedMode: PropTypes.bool,
  params: PropTypes.shape({
    id: PropTypes.string.isRequired,
  }).isRequired,
};

ScreeningHistorySection.defaultProps = {
  className: '',
  embeddedMode: false,
};
